import { render, staticRenderFns } from "./OrganizationLogView.vue?vue&type=template&id=4555d6e1&"
import script from "./OrganizationLogView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationLogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4555d6e1')) {
      api.createRecord('4555d6e1', component.options)
    } else {
      api.reload('4555d6e1', component.options)
    }
    module.hot.accept("./OrganizationLogView.vue?vue&type=template&id=4555d6e1&", function () {
      api.rerender('4555d6e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/log/OrganizationLogView.vue"
export default component.exports